export const walletParserModes = [
  { id: 'auto', label: 'auto' },
  { id: 'off', label: 'off' },
  { id: 'pause', label: 'pause' },
];
